import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {keyboardHandler, textCursorSelectAll} from '@containers/hooks'

interface Output {
  hours: number
  minutes: number
  floatHours: number
  isOk: boolean
}

interface Props {
  initial?: number // float-point formatted hours
  model: Model
  save: () => void
  close?: () => boolean | void
  className?: string
}

interface Model {
  getValue: () => Output
}

const convertToHours = (hours: number, minutes: number): number =>
  hours + +(minutes / 60).toFixed(5)

export const makeHoursMinutesModel = (): Model => ({
  getValue: () => undefined
})

const isInt = (num: number): boolean => num === +num?.toFixed(0)

export const HoursMinutesInput = (props: Props) => {
  const {initial = 0, model, save, close, className} = props
  const bem = Util.bemFrom('hours-minutes-input', [className])

  const [hours, setHours] = React.useState(Math.floor(initial) + '')
  const [minutes, setMinutes] = React.useState(
    Math.round(60 * (initial - Math.floor(initial))) + ''
  )
  const minuteRef = React.useRef<HTMLInputElement>()
  const changeHours = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isNaN(+e.target.value)) {
      return
    }
    setHours(e.target.value)
  }
  const changeMinutes = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isNaN(+e.target.value)) {
      return
    }
    setMinutes(e.target.value)
  }

  const isHoursOk =
    hours === '' || (isInt(+hours) && +hours >= 0 && +hours < 100000)
  const isMinutesOk =
    minutes === '' ||
    (isInt(+minutes) && +minutes >= 0 && +minutes < 60 && +minutes < 100000)

  React.useEffect(() => {
    if (!model) {
      return
    }
    model.getValue = () => ({
      hours: +hours,
      minutes: +minutes,
      floatHours: convertToHours(+hours || 0, +minutes || 0),
      isOk: isHoursOk && isMinutesOk
    })
  }, [hours, minutes, model])

  return (
    <div className={bem()}>
      <input
        className={bem('input', {error: !isHoursOk})}
        type="text"
        onChange={changeHours}
        autoFocus={true}
        onFocus={textCursorSelectAll}
        value={hours}
        onKeyDown={keyboardHandler({
          enter: () => minuteRef.current.focus(),
          escape: close
        })}
      />
      <span className={bem('unit')}>{Lang.msg.h}</span>
      <input
        className={bem('input', {error: !isMinutesOk})}
        type="text"
        onChange={changeMinutes}
        onFocus={textCursorSelectAll}
        value={minutes}
        onKeyDown={keyboardHandler({enter: save, escape: close})}
        ref={minuteRef}
      />
      <span className={bem('unit')}>{Lang.msg.mShort}</span>
    </div>
  )
}
